const updates = [
  { time: '今天 15:42', title: '某知名男星被拍到深夜出入夜店，与多名女子互动亲密', tag: '最新' },
  { time: '今天 13:18', title: '某综艺节目选手后台争吵视频曝光，场面一度失控', tag: '独家' },
  { time: '今天 10:55', title: '某平台顶流主播被爆私下辱骂粉丝，录音证据公开', tag: '热门' },
  { time: '昨天 22:30', title: '某企业高管涉嫌利益输送被内部举报，相关部门已介入', tag: '追踪' },
  { time: '昨天 18:14', title: '某网红被曝学历造假，真实背景与公开信息严重不符', tag: '独家' },
  { time: '昨天 14:02', title: '某知名歌手新歌被指抄袭，对比音频引发网友热议', tag: '热门' },
  { time: '昨天 09:45', title: '某女星与经纪人合同纠纷细节曝光，涉及金额超千万', tag: '追踪' },
  { time: '前天 20:33', title: '某直播带货主播产品质检不合格，消费者集体投诉', tag: '最新' },
  { time: '前天 16:11', title: '某知名导演新片拍摄现场发生意外，剧组紧急停工', tag: '热门' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-timer-flash-fill"></i>
            实时动态
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            更新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            黑料网下载内容动态，最新吃瓜资讯滚动更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 before:absolute before:left-[11px] before:top-2 before:bottom-2 before:w-0.5 before:bg-secondary-200">
            {updates.map((item, i) => (
              <div key={i} className="relative pb-5 md:pb-6 last:pb-0 group cursor-pointer">
                <div className="absolute left-[-32px] md:left-[-40px] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100 group-hover:scale-125 transition-transform"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                  <span className="text-xs text-foreground-400 whitespace-nowrap shrink-0">{item.time}</span>
                  <span className="text-sm md:text-base text-foreground-700 group-hover:text-primary-500 transition-colors flex-1">
                    {item.title}
                  </span>
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium shrink-0 w-fit ${
                    item.tag === '最新' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '独家' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '追踪' ? 'bg-secondary-100 text-secondary-700' :
                    'bg-primary-100 text-primary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}